export type RewardsCustomerRewardsQueryParams = {
    locale: string;
};

export enum REWARDS_CUSTOMER_ACTIVE_REWARDS_TYPES {
    reward = "reward",
    redeem = "redeem",
    tier = "tier",
    referrer = "referrer",
    referred = "referred",
}

export const REWARDS_CUSTOMER_DELAYED_REWARDS_TYPES = {
    shareTheShopRewardDelay: "shareTheShopRewardDelay",
    followOnTiktokRewardDelay: "followOnTiktokRewardDelay",
    followOnYoutubeRewardDelay: "followOnYoutubeRewardDelay",
    newsletterSubscribeRewardDelay: "newsletterSubscribeRewardDelay",
    facebookPageVisitRewardDelay: "facebookPageVisitRewardDelay",
    followOnInstagramRewardDelay: "followOnInstagramRewardDelay",
    leaveReviewRewardDelay: "leaveReviewRewardDelay",
    placeOrderRewardDelay: "placeOrderRewardDelay",
    createAccountRewardDelay: "createAccountRewardDelay",
    buyXtoGetYRewardDelay: "buyXtoGetYRewardDelay",
    spendXToGetYRewardDelay: "spendXToGetYRewardDelay",
    shareToTwitterRewardDelay: "shareToTwitterRewardDelay",
    shareToFacebookRewardDelay: "shareToFacebookRewardDelay",
    followOnTwitterRewardDelay: "followOnTwitterRewardDelay",
    punchCardRewardDelay: "punchCardRewardDelay",
    customActionRewardDelay: "customActionRewardDelay",
} as const;
